// NOVO ARQUIVO
import React, { useState } from 'react';
import Modal from '../ui/Modal';
import GlassButton from '../ui/Button';
import InputField from '../ui/InputField';

const SaveThemeModal = ({ isOpen, onClose, onSave }) => {
    const [themeName, setThemeName] = useState('');

    const handleSave = () => {
        if (themeName.trim()) {
            onSave(themeName);
            onClose();
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} maxWidth="max-w-md">
            <div className="p-6">
                <h2 className="text-2xl font-bold text-white mb-4">Salvar Tema</h2>
                <InputField
                    label="Nome do Tema"
                    name="themeName"
                    value={themeName}
                    onChange={(e) => setThemeName(e.target.value)}
                    placeholder="Ex: Moderno, Corporativo..."
                    required
                />
            </div>
            <div className="p-6 flex justify-end space-x-4 bg-black/20 rounded-b-2xl">
                <GlassButton onClick={onClose} variant="minimal">
                    Cancelar
                </GlassButton>
                <GlassButton onClick={handleSave} className="!bg-indigo-500">
                    Salvar Tema
                </GlassButton>
            </div>
        </Modal>
    );
};

export default SaveThemeModal;